import React from 'react';
import { Typography } from 'fronton-react';
import { useBreakpoints } from 'common';
import { imgStyle, liStyle, modalContentElementTextStyle, ulStyle } from './styles';
import { ModalContentElementProps, ModalContentProps } from './types';

export const StoreModalContentElement: React.FC<ModalContentElementProps> = ({ icon, text }) => (
  <li className={liStyle}>
    <div className={imgStyle}>{icon}</div>
    <div className={modalContentElementTextStyle}>
      <Typography size="body_short" variant="m">
        {text}
      </Typography>
    </div>
  </li>
);

export const StoreModalContent: React.FC<ModalContentProps> = ({ content }) => {
  const { smMobile } = useBreakpoints() || {
    smMobile: false,
  };
  return (
    <ul className={ulStyle}>
      {content.map(({ icon, text }) => {
        const iconWithSize = React.cloneElement(icon, { size: smMobile ? '24' : '32' });
        return <StoreModalContentElement icon={iconWithSize} text={text} key={text} />;
      })}
    </ul>
  );
};
